import { animated, useSpring } from '@react-spring/web';
import { forwardRef, useState } from 'react';
import { Grid } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
// ---------- components ------------------
import loadingGif from 'assets/gif/FreeSensLoader05.gif';
import { validateSharePhoneNumber } from 'utils/functions-utils';
import SmsSent from './sms-sent';
import styles from 'assets/css/share-modal.module.css';
import MainView from './main-view';
import { useGetShareToken, useSendSMS } from 'modules/report/hooks/useSMS';
import SendToOther from './send-to-other';
import { useGetPatientInfo } from 'modules/report/hooks/usePatientInfo';
import { useSearchParams } from 'react-router-dom';

// modal fade
const Fade = forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    }
  });
  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

const ShareModal = (props) => {
 const [searchParams] = useSearchParams();
  const patientId = searchParams.get('patientId')

  const [delivered, setDelivered] = useState(null);
  const [open, setOpen] = useState(false);
  const [addPhoneNumber, setAddPhoneNumber] = useState(false);

  const getShareToken = useGetShareToken();

  const sendReportLink = useSendSMS(setDelivered);
  const { data: patientInfo } = useGetPatientInfo(patientId);
  const { firstName, lastName, phoneNumber } = patientInfo || {};
  const shareUrl = `${process.env.REACT_APP_SHARE_BASE_URL}/app/report/share/${getShareToken?.data?.token}`;

  const [isCopied, setCopied] = useState(false);

  function copyToClipboard(text) {
    // Create a temporary textarea element
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);

    // Select the text in the textarea
    textarea.select();
    try {
      // Execute copy command
      const successful = document.execCommand('copy');
      if (successful) {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
        console.log('Text successfully copied to clipboard');
      } else {
        console.error('Unable to copy text to clipboard');
      }
    } catch (err) {
      console.error('Unable to copy text to clipboard', err);
    } finally {
      // Remove the temporary textarea from the DOM
      document.body.removeChild(textarea);
    }
  }
  //  content for sharing at social media
  const shareContent = `
  این لینک حاوی گزارش قندخون "${firstName ? firstName : ''} ${
    lastName ? lastName : ''
  }" در اپلیکیشن فریسنس میباشد : 
  ${'                                                         '}    
    ${shareUrl}
 ${'                                                         '} 
    - این لینک تا 30 روز آینده قابل مشاهده است.`;

  //  open DeleteAgentModal
  const handleOpen = (e) => {
    setOpen(true);
    getShareToken.mutate({
      patientId
    });
    e.stopPropagation();
  };
  // close and reset modal states
  const handleClose = (e) => {
    setAddPhoneNumber(false);
    setOpen(false);
    setDelivered(null);
    e.stopPropagation();
  };

  const sendSMSHandler = (phoneNumber) => {
    // validate phoneNumber before post req
    const validatePhoneNum = validateSharePhoneNumber(phoneNumber);
    if (!validatePhoneNum && getShareToken?.data?.id) {
      sendReportLink.mutate({
        id: getShareToken?.data?.id,
        phoneNumber
      });
    }
  };

  const sendSmsToOther = () => setAddPhoneNumber(true);

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <div onClick={handleOpen}>{props.children}</div>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={open}
        onClose={(e) => handleClose(e)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        hideBackdrop
      >
        <>
          <Backdrop
            sx={{
              background: 'rgba(216, 216, 216, 0.3)',
              backdropFilter: 'blur(6.7957px)',
              transition: 'ease-in-out 0.2s !important',
              zIndex: '0'
            }}
            open={open}
            onClick={(e) => handleClose(e)}
          />
          <Fade in={open}>
            <Grid className={styles.container} container>
              {getShareToken.isLoading ? (
                <Grid container xs={12} mb={8}>
                  <img
                    src={loadingGif}
                    alt=""
                    className={styles.loadingStyle}
                  />
                </Grid>
              ) : addPhoneNumber ? (
                <SendToOther
                  delivered={delivered}
                  sendSMSHandler={sendSMSHandler}
                  handleCloseModal={handleClose}
                  name={`${firstName} ${lastName}`}
                />
              ) : delivered ? (
                <SmsSent
                  phoneNumber={phoneNumber}
                  handleCloseModal={handleClose}
                />
              ) : (
                <MainView
                  value={shareUrl}
                  setCopied={copyToClipboard}
                  isCopied={isCopied}
                  shareContent={shareContent}
                  smsToOtherHandler={sendSmsToOther}
                  sendSMSHandler={sendSMSHandler}
                  phoneNumber={phoneNumber}
                  handleClose={handleClose}
                />
              )}
            </Grid>
          </Fade>
        </>
      </Modal>
    </div>
  );
};

export default ShareModal;
